import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem("cookie-consent", value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.33, 1, 0.68, 1] }}
          data-testid="cookie-banner"
          className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-3xl rounded-3xl border border-ink/10 bg-bg-primary/95 p-6 shadow-2xl backdrop-blur-xl md:p-7"
        >
          <p className="font-serif text-xl text-ink">Tu privacidad importa</p>
          <p className="mt-2 text-sm leading-relaxed text-ink-soft">
            Usamos cookies propias necesarias para el funcionamiento del sitio y, con tu permiso, cookies de
            medición. No hay casillas premarcadas. Consulta nuestra{" "}
            <Link to="/politica-cookies" className="underline underline-offset-2 hover:text-sage-dark">
              Política de cookies
            </Link>
            .
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <button
              onClick={() => decide("accepted")}
              data-testid="cookie-accept-button"
              className="rounded-full bg-ink px-6 py-3 text-sm font-medium text-bg-primary transition-colors duration-300 hover:bg-sage-dark"
            >
              Aceptar
            </button>
            <button
              onClick={() => decide("rejected")}
              data-testid="cookie-reject-button"
              className="rounded-full border border-ink/20 px-6 py-3 text-sm font-medium text-ink transition-colors duration-300 hover:bg-ink/5"
            >
              Rechazar
            </button>
            <Link
              to="/politica-cookies"
              onClick={() => setVisible(false)}
              data-testid="cookie-config-link"
              className="rounded-full border border-ink/20 px-6 py-3 text-sm font-medium text-ink transition-colors duration-300 hover:bg-ink/5"
            >
              Configurar
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
